import React from 'react';
import useClassNames from 'helpers/hooks/useClassNames';
import useControllableState from 'helpers/hooks/useControllable';

interface Props extends Omit<React.ComponentProps<'input'>, 'key'> {
  className?: string;
  inputClassName?: string;
  onChecked?: () => void;
  labelClassName?: string;
}

const Radio: React.FC<Props> = ({
  className = '',
  inputClassName = '',
  onChecked,
  children,
  checked: checkedProp,
  defaultChecked = false,
  onChange,
  labelClassName = '',
  ...props
}) => {
  const [checked, setChecked] = useControllableState(checkedProp, defaultChecked);

  const inputClassNames = useClassNames(['h-12 w-12 border-0 text-blue cursor-pointer', inputClassName]);
  const radioContainerClassNames = useClassNames([
    'grid h-18 w-18 place-content-center rounded-full outline outline-2',
    { 'outline-blue': checked },
    { 'outline-stroke-secondary': !checked },
  ]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    onChecked?.();
    setChecked(true);
  };

  return (
    <div className={`flex gap-x-12 ${className}`}>
      <div className={radioContainerClassNames}>
        <input
          className={inputClassNames}
          type="radio"
          checked={checked}
          onChange={(e) => handleChange(e)}
          {...props}
        />
      </div>
      {children && (
        <label htmlFor={props.id} className={labelClassName}>
          {children}
        </label>
      )}
    </div>
  );
};

export default Radio;
